// Import Firebase SDKs
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

// ✅ Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDWkP7zvErokJPEO9enqVXi_s0vGOfLjRI",
  authDomain: "pb-ott.firebaseapp.com",
  databaseURL: "https://pb-ott-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "pb-ott",
  storageBucket: "pb-ott.firebasestorage.app",
  messagingSenderId: "355785400245",
  appId: "1:355785400245:web:be059a8a390acfa09a83fc",
  measurementId: "G-XJHCQS948N",
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);

// ⚠️ Important: getAnalytics must only be called in a **browser environment**
// (it will fail if used in Node.js / SSR)
let analytics;
if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}

// ✅ Export for use in other files
export { app, analytics, logEvent };